// extracted by mini-css-extract-plugin
export default {"extra":"TemplateList_extra__4aah4","ant-input-affix-wrapper":"TemplateList_ant-input-affix-wrapper__DhPOj","breadCrump":"TemplateList_breadCrump__hsiwY"};